export default function HeroSection() {
  return (
    <section className="relative min-h-[600px] flex items-center justify-center overflow-hidden">
      <div 
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/2c72ad0d3157ef4b69915aa70fad4e73.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-transparent"></div>
      </div>
      
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 py-20">
        <div className="max-w-3xl">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
            香港機遇，觸手可及
          </h1>
          <p className="text-2xl md:text-3xl text-white/90 mb-8 font-light">
            全方位香港移居與人才入境計劃指南
          </p>
          <p className="text-xl text-white/80 mb-10 leading-relaxed">
            從高端人才到投資移民，萬業人才資本為您規劃最合適的赴港路徑
          </p>
          <div className="flex flex-wrap gap-4">
            <a 
              href="#schemes" 
              className="inline-flex items-center px-8 py-4 bg-teal-500 text-white font-semibold rounded-lg hover:bg-teal-600 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              探索移居計劃
              <i className="ri-arrow-right-line ml-2 text-xl"></i>
            </a>
            <a 
              href="#contact" 
              className="inline-flex items-center px-8 py-4 bg-white/10 backdrop-blur-sm text-white font-semibold rounded-lg hover:bg-white/20 transition-all duration-300 border-2 border-white/30 whitespace-nowrap cursor-pointer"
            >
              免費評估
              <i className="ri-chat-check-line ml-2 text-xl"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
